import { IFormService } from "../../service/form/FormService";

export default class GetFormReportInteractor {
  private formService: IFormService;

  constructor(formService) {
    this.formService = formService;
  }

  async execute(formVersionId: number, languageCode: number) {
    return this.formService.getFormReport(formVersionId, languageCode);
  }
}
